$(function () {
  $("input[type=radio][name^=js-tour-type-radio]").change(function (event) {
    $(event.target)
      .closest(".js-booking-section")
      .find(".js-tour-wrapper-item")
      .removeClass("is-active");

    let radioTarget = event.target.getAttribute("target") 
    $(`#${radioTarget}`).addClass("is-active");

    if(radioTarget === 'js-offline-tour-section') {
      if(!Boolean(window.localStorage.getItem(`${window.prefixSearchHistory}-offline-trip-tab`)))
        window.localStorage.setItem(`${window.prefixSearchHistory}-offline-trip-tab`, `[]`)
    }

    else if(radioTarget === 'js-online-tour-section') {
      if(!Boolean(window.localStorage.getItem(`${window.prefixSearchHistory}-online-trip-tab`)))
        window.localStorage.setItem(`${window.prefixSearchHistory}-online-trip-tab`, `[]`)
    }
    createSearchHistoryCard()
  });
});
